import { useCallback } from 'react';

import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid';

export default function SortActionsFormatter({ info }) {
  const { state: { term, filters } } = useGrid()
  const { row: { index } } = info

  if (term || filters) {
    return null
  }

  return <div className="flex items-center flex-col justify-center p-0 m-0 pl-2">
    <SortAction Icon={ChevronUp} index={index} direction={-1} />
    <SortAction Icon={ChevronDown} index={index} direction={1} />
  </div>
}

function SortAction({ Icon, index, direction }) {
  const { events: { handleSortEntry } } = useGrid()

  const handleSort = useCallback(async () => {
    await handleSortEntry(index, direction)
  }, [handleSortEntry, index, direction])

  return <Button className='py-0' color='neutral' variant='ghost' size='sm' onClick={handleSort}>
    <Icon size={16} strokeWidth={2} />
  </Button>
}
